import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/brand/gyre-icon-sm-rounded.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1f3a1f20"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "app",
  class: "container text-big"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px"} }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div style=\"height:30px;\" data-v-1f3a1f20></div><p data-v-1f3a1f20> Gyre uses a proxy so that you can use Hot Module Replacement against the main Gyre site. Click the Home button to try that out. You need to be running the site through Visual Studio for that to work. If you&#39;re redirected to this page from somewhere else, this page will redirect you on to &quot;/home&quot;. </p><p data-v-1f3a1f20> You can also develop ui against characterscope-dev.azurewebsites.net by running &#39;npm run serve:cs-dev&quot;. </p><div style=\"position:absolute;width:100%;height:70px;top:0;left:0;background:#f2f2f2;\" data-v-1f3a1f20><a href=\"/home\" style=\"position:absolute;top:14px;left:15px;font-size:30px;\" data-v-1f3a1f20><img src=\"" + _imports_0 + "\" style=\"width:30px;position:relative;top:-5px;\" alt=\"brand icon\" data-v-1f3a1f20> Home </a></div><a href=\"/demo\" style=\"position:absolute;top:14px;right:240px;font-size:30px;\" data-v-1f3a1f20><span class=\"glyphicon glyphicon-play-circle\" data-v-1f3a1f20></span> Demos </a><a href=\"/test\" style=\"position:absolute;top:14px;right:15px;font-size:30px;\" data-v-1f3a1f20><span class=\"glyphicon glyphicon-list-alt\" data-v-1f3a1f20></span> Test Panel </a>", 6)

import { onMounted, computed } from "vue";
import cms from "./services/cms/cms";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const proxyUrl = computed(() => process.env.VUE_APP_MY_CS_URL);

onMounted(() => {
  cms.handlePreviewing();
  if (document.referrer && document.referrer.includes("localhost")) {
    window.location.replace("/home");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h1", null, [
      _createTextVNode(" Gyre Ui Development Mode "),
      _hoisted_3,
      _createElementVNode("small", null, "Proxying against " + _toDisplayString(proxyUrl.value), 1)
    ]),
    _hoisted_4
  ]))
}
}

})